import { CustomButton } from 'components/ui'
import Dropdown, { DropDownItem } from 'components/ui/Dropdown/Dropdown'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ModalDeleteActividadAdmin from './ModalDeleteActividadAdmin'
import { useUpdateActividad } from 'lib/react-query/queriesActividad'

const ActividadesRowAdmin = ({ item, highlightInactive = false }) => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [openModal, setIsOpenModal] = useState(false)
  const { mutateAsync: updateActividad } = useUpdateActividad()

  const handleOnClickDisable = () => {
    updateActividad({ id: item._id, active: false })
  }

  const handleOnClickEnable = () => {
    updateActividad({ id: item._id, active: true })
  }

  return (
    <>
      <tr
        className={`fabrica-table-header ${highlightInactive ? 'row-inactivo' : ''}`}
      >
        <td>{item?.code}</td>
        <td>{item?.name}</td>
        <td className="container-buttons-row-articulo">
          <Dropdown
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            button={
              <CustomButton
                type="secondary"
                className="button-edit-articulo-price"
                onClick={() => setIsOpen(prevState => !prevState)}
              >
                <MoreVertIcon />
              </CustomButton>
            }
          >
            <DropDownItem
              item="Editar actividad"
              onClick={() =>
                navigate(`/admin/actividades/edit-actividad/${item._id}`)
              }
            ></DropDownItem>
            {item.active === false ? (
              <DropDownItem
                item="Habilitar actividad"
                onClick={handleOnClickEnable}
              />
            ) : (
              <DropDownItem
                item="Deshabilitar actividad"
                onClick={handleOnClickDisable}
              />
            )}
            <DropDownItem
              item="Eliminar actividad"
              onClick={() => setIsOpenModal(true)}
            ></DropDownItem>
          </Dropdown>
        </td>
      </tr>
      {openModal && (
        <ModalDeleteActividadAdmin
          handleOnClose={() => setIsOpenModal(false)}
          actividad={item}
        />
      )}
    </>
  )
}

export default ActividadesRowAdmin
